import axios from "axios";
import { API_BASE } from "../../lib/api";

// Create an Axios instance with a base URL
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Handle login — token is set as httpOnly cookie by the server
export async function loginApi(username, password) {
  try {
    const response = await api.post("/login", { username, password });
    const { user } = response.data;
    return { user };
  } catch (error) {
    throw new Error(error.response?.data?.error || "Login failed");
  }
}

// Handle logout — clears the httpOnly cookie on the server
export async function logoutApi() {
  try {
    await api.post("/logout");
  } catch (error) {
    // Logout failed silently
  }
}

// Fetch user data (Example usage)
export async function fetchUserData() {
  try {
    const response = await api.get("/user_data_endpoint");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || "Failed to fetch user data");
  }
}

// Register a new user (Example usage)
export async function registerUser(userData) {
  try {
    const response = await api.post("/register", userData);

    if (!response.data) {
      throw new Error("No response from server");
    }

    if (response.data.success === false || (response.data.error && !response.data.userId)) {
      throw new Error(response.data.error || "Registration failed");
    }

    if (!response.data.userId && !response.data.id) {
      throw new Error("Registration response missing user ID");
    }

    return response.data;
  } catch (error) {
    
    // Handle network errors
    if (error.code === 'ECONNREFUSED' || error.code === 'ERR_NETWORK') {
      throw new Error("Cannot connect to server. Please check if the API server is running.");
    }
    
    // Handle CORS errors
    if (error.message?.includes('CORS') || error.message?.includes('Access-Control')) {
      throw new Error("CORS error. Please check server configuration.");
    }
    
    // Handle rate limiting
    if (error.response?.status === 429) {
      throw new Error("Too many registration attempts. Please try again later.");
    }
    
    // Handle specific error messages from backend
    const errorMessage = error.response?.data?.error || error.message || "Registration failed";
    throw new Error(errorMessage);
  }
}

export async function fetchMembership() {
  try {
    const response = await api.get("/user_data_endpoint/membership");
    return response.data.membership;
  } catch (error) {
    throw error;
  }
}

export default api;
